/*
 * @Author: Jing
 * @Date: 2021-12-14 10:31:58
 * @Descripttion: 公共函数库
 */
import { height, bmi } from './bmi'
import Cookies from 'js-cookie'
import type { wxConfigParam } from '#/wx'
import type { ResponseData } from '#/axios'
import { postWxConfig } from '@/api/index'
import { getAppEnvConfig } from '@/utils/env'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault('Asia/Shanghai')

import wx from 'weixin-js-sdk'

// 设置页面标题
export const setTitle = (title: string) => {
    title = title ? title : ''
    window.document.title = title
}

// 操作缓存
export const storageGet = (key: string) => {
    if (!key) return
    return window.localStorage.getItem(key)
}
export const storageSet = function (key: string, val: string | object) {
    if (!key) return
    if (typeof val !== 'string') {
        val = JSON.stringify(val)
    }
    window.localStorage.setItem(key, val)
}
export const storageRemove = function (key: string) {
    if (!key) return
    window.localStorage.removeItem(key)
}

export const sessionGet = (key: string) => {
    if (!key) return
    return window.sessionStorage.getItem(key)
}
export const sessionSet = (key: string, val: string | object) => {
    if (!key) return
    if (typeof val !== 'string') {
        val = JSON.stringify(val)
    }
    window.sessionStorage.setItem(key, val)
}
export const sessionRemove = (key: string) => {
    if (!key) return
    window.sessionStorage.removeItem(key)
}

// 判断授权登录
export const checkLogin = function () {
    let { VITE_COOKIE_KEY } = getAppEnvConfig()
    let token = Cookies.get(VITE_COOKIE_KEY)
    if (token) {
        return true
    } else {
        return false
    }
}

const skipAuth = ['/order/pay', '/noauth', '/error', '/authorize']
export function inSkipAuth(url: string) {
    return skipAuth.includes(url)
    // return skipAuth.find((i) => url.includes(i))
}

export const getWechatConf = (data: wxConfigParam) => {
    return new Promise(async (resolve, reject) => {
        let url = window.location.href
        // alert(data.url || url)
        let res: any = await postWxConfig({
            brandId: data.brandId,
            // url: 'https://m-rel.ruolinzs.com',
            url: data.url || url,
        })
        console.log('获取微信配置', res)
        if (res.code == '00') {
            wx.config({
                // debug: true,
                debug: false,
                appId: res.data.appId,
                timestamp: res.data.timestamp,
                nonceStr: res.data.nonceStr,
                signature: res.data.signature,
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'showMenuItems', 'hideMenuItems', 'getLocation', 'openLocation'],
            })
            resolve(true)
        } else {
            reject(false)
        }
    })
}

// 微信分享
export const getShare = async (data: wxConfigParam) => {
    let resp = await getWechatConf(data)
    console.log('获取微信配置返回结果')
    if (resp) {
        wx.ready(function () {
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
                title: data.title, // 分享标题
                desc: data.desc, // 分享描述
                link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://kchi.obs.cn-north-4.myhuaweicloud.com/jsd-clinic-web/clinic-wechat/index/logo.png', // 分享图标
                success: function () { },
            })
            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
                title: data.title, // 分享标题
                link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://kchi.obs.cn-north-4.myhuaweicloud.com/jsd-clinic-web/clinic-wechat/index/logo.png', // 分享图标
                success: function () { },
            })
        })
        wx.error(function (res: any) {
            console.log('获取微信配置报错', res)
        })
    }
}
// 微信支付
// export const wechatPay = async () => {
//     return new Promise((resolve, reject) => {
//         wx.ready(function () {
//             wx.chooseWXPay({
//                 timestamp: 0, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
//                 nonceStr: '', // 支付签名随机串，不长于 32 位
//                 package: '', // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
//                 signType: '', // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
//                 paySign: '', // 支付签名
//                 success: function (res) {
//                     // 支付成功后的回调函数
//                 },
//             })
//         })
//     })
// }
// 显示微信分享按钮
export const showWxShareMenu = () => {
    if (wx) {
        wx.ready(function () {
            wx.showMenuItems({
                menuList: [
                    'menuItem:share:appMessage', // 发送给朋友
                    'menuItem:share:timeline', // 分享到朋友圈
                    'menuItem:share:qq', // 分享到QQ
                    'menuItem:share:weiboApp', // 分享到Weibo
                    'menuItem:favorite', // 收藏
                    'menuItem:share:facebook', // 分享到FB
                    'menuItem:share:QZone', // 分享到 QQ 空间
                ],
            })
        })
    }
}
// 隐藏微信分享按钮
export const hideWxShareMenu = () => {
    if (wx) {
        wx.ready(function () {
            wx.hideMenuItems({
                menuList: [
                    'menuItem:share:appMessage', // 发送给朋友
                    'menuItem:share:timeline', // 分享到朋友圈
                    'menuItem:share:qq', // 分享到QQ
                    'menuItem:share:weiboApp', // 分享到Weibo
                    'menuItem:favorite', // 收藏
                    'menuItem:share:facebook', // 分享到FB
                    'menuItem:share:QZone', // 分享到 QQ 空间
                ],
            })
        })
    }
}

// 转换保存到后台的金额
export function dbPrice(price: Number) {
    if (!price) return 0
    let num = String(Number(price))
    if (num == 'NaN') return 0
    let split = num.split('.')
    let decimal = ''
    //超过4位小数
    if (split[1] && split[1].length > 4) {
        decimal = split[1].slice(0, 4)
    } else {
        //不足4位补0
        decimal = split[1] || '0'
        let pad = decimal ? 4 - decimal.length : 4
        decimal = decimal + '0'.repeat(pad)
    }
    return split[0] + decimal
}

export function isImage(ext: string) {
    return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(ext.toLowerCase()) !== -1
}
export function formatSrc(url: string) {
    if (!url) return '@/assets/image/no_pic.jpg'
    let host = window.location.origin + '/'
    if (url.startsWith('http')) {
        return url
    } else {
        return host + url
    }
}
export function ellipsis(str: string, len: number) {
    var strLength = 0
    var strLen = 0
    var strCut = ''
    strLen = str.length
    for (var i = 0; i < strLen; i++) {
        var a = str.charAt(i)
        strLength++
        if (escape(a).length > 4) {
            // 中文字符的长度经编码之后大于4
            strLength++
        }
        strCut = strCut.concat(a)
        if (strLength >= len) {
            strCut = strCut.concat('...')
            return strCut
        }
    }
    // 如果给定字符串小于指定长度，则返回源字符串
    if (strLength < len) {
        return str
    }
}
/**
 * [calcHeightP 计算身高P值]
 * @param  {[type]} val                [身高]
 * @param  {[type]} sex                [性别]
 * @param  {[type]} age                [出生日期]
 * @param  {[type]} date               [录入日期]
 * @return {[type]}      [返回参数]
 */
export const calcHeightP = (val: string | number, sex: string | number, age: string | number, date?: Date) => {
    if (val) {
        let ageMonth = date ? Math.ceil(dayjs.tz(date).diff(dayjs.tz(age), 'months', true)) : Math.ceil(dayjs.tz(new Date()).diff(dayjs.tz(age), 'months', true))
        let month: number = ageMonth > 228 ? 228 : ageMonth
        let sexStr: string = sex == 1 ? 'boy' : sex == 2 ? 'girl' : ''
        if (sexStr) {
            let pArr = (height as any)[month][sexStr]
            /*
                重度矮小: < arr[0]
                中度矮小: >= arr[0] && < arr[1]
                轻度矮小: >= arr[1] && < arr[2]
                正常:    >= arr[2] && < arr[3]
                身材优等: >= arr[3] && <= arr[4]
                超高:    > arr[4]
            */
            // 身高 {"1":"重度矮小","2":"中度矮小","3":"轻度矮小","4":"正常","5":"身材优等","6":"超高"}
            if (val < pArr[0]) {
                return 1
            } else if (val >= pArr[0] && val < pArr[1]) {
                return 2
            } else if (val >= pArr[1] && val < pArr[2]) {
                return 3
            } else if (val >= pArr[2] && val < pArr[3]) {
                return 4
            } else if (val >= pArr[3] && val < pArr[4]) {
                return 5
            } else if (val > pArr[4]) {
                return 6
            }
        } else {
            return ''
        }
    } else {
        return ''
    }
}

/**
 * [calcBmiP 计算BMI值]
 * @param  {[type]} val                [BMI值]
 * @param  {[type]} sex                [性别]
 * @param  {[type]} age                [出生日期]
 * @param  {[type]} date               [录入日期]
 * @return {[type]}      [返回值]
 */
export const calcBmiP = (val: string | number, sex: string | number, age: string | number, date?: Date) => {
    if (val) {
        let ageMonth = date ? Math.ceil(dayjs.tz(date).diff(dayjs.tz(age), 'months', true)) : Math.ceil(dayjs.tz(new Date()).diff(dayjs.tz(age), 'months', true))
        let month = ageMonth > 228 ? 228 : ageMonth
        let sexStr = sex == 1 ? 'boy' : sex == 2 ? 'girl' : ''
        if (sexStr) {
            let pArr = (bmi as any)[month][sexStr]
            // 体重 BMI {"1":"瘦小","2":"偏瘦","3":"正常","4":"偏重","5":"超重"}
            /*
                瘦小: < arr[0]
                偏瘦: >= arr[0] && < arr[1]
                正常: >= arr[1] && < arr[3]
                偏重: > arr[3] && <= arr[4]
                超重: > arr[4]
            */
            if (val < pArr[0]) {
                return 1
            } else if (val >= pArr[0] && val < pArr[1]) {
                return 2
            } else if (val >= pArr[1] && val < pArr[3]) {
                return 3
            } else if (val >= pArr[3] && val <= pArr[4]) {
                return 4
            } else if (val > pArr[4]) {
                return 5
            }
        } else {
            return ''
        }
    } else {
        return ''
    }
}
export const calcAgeEnum = (age: any, date?: Date) => {
    if (age) {
        let ageDay = date ? Math.ceil(dayjs.tz(date).diff(dayjs.tz(age), 'days', true)) : Math.ceil(dayjs.tz(new Date()).diff(dayjs.tz(age), 'days', true))
        // "1":"新生儿期 (0~28天）","2":"婴儿期(28天~1岁）","3":"幼儿期 (1岁~3岁)","4":"学龄前期(3岁~7岁)","5":"学龄期(7岁~11岁)","6":"青春期(11岁~18岁)","7":"青年期 (18岁～35岁)" 中年期（35岁~60岁） 老年期（>60岁）
        if (ageDay <= 28) {
            return 1
        } else if (ageDay > 28 && ageDay <= 365) {
            return 2
        } else if (ageDay > 365 && ageDay <= 1095) {
            return 3
        } else if (ageDay > 1095 && ageDay <= 2555) {
            return 4
        } else if (ageDay > 2555 && ageDay <= 4015) {
            return 5
        } else if (ageDay > 4015 && ageDay <= 6570) {
            return 6
        } else if (ageDay > 6570 && ageDay <= 12775) {
            return 7
        } else if (ageDay > 12775 && ageDay <= 21900) {
            return 8
        } else if (ageDay > 21900) {
            return 9
        }
    } else {
        return ''
    }
}

export function phone(val: string): boolean {
    if (!val) return false
    return !!val.match(/^1[1-9]\d{9}$/)
}

export function fill0(num: any) {
    return num < 10 ? '0' + num : num
}

export function formatDataBy(date: any, div: any) {
    if (date instanceof Date) {
        var m = date.getMonth() + 1
        m = fill0(m)

        var d = date.getDate()
        d = fill0(d)

        var y = date.getFullYear()

        return y + div + m + div + d
    }
    return ''
}

export function verificationIDCard(cardNo: string, type: number) {
    // 验证身份证
    var idReg = new RegExp('(^\\d{15}|\\d{17}(\\d{1}|X|x)$)')
    // 护照
    var passportReg = new RegExp('(^([PSE]{1}\\d{7}|[GS]{1}\\d{8})$)')
    switch (type) {
        case 1: // 身份证
            if (idReg.test(cardNo)) {
                return true
            } else {
                return false
            }
            break
        case 2: // 护照
            if (passportReg.test(cardNo)) {
                return true
            } else {
                return false
            }
            break
        default:
            if (idReg.test(cardNo) || passportReg.test(cardNo)) {
                return true
            } else {
                return false
            }
            break
    }
}
